import { render, staticRenderFns } from "./PreviewEject.vue?vue&type=template&id=3d577e29&scoped=true"
import script from "./PreviewEject.vue?vue&type=script&lang=js"
export * from "./PreviewEject.vue?vue&type=script&lang=js"
import style0 from "./PreviewEject.vue?vue&type=style&index=0&id=3d577e29&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d577e29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d577e29')) {
      api.createRecord('3d577e29', component.options)
    } else {
      api.reload('3d577e29', component.options)
    }
    module.hot.accept("./PreviewEject.vue?vue&type=template&id=3d577e29&scoped=true", function () {
      api.rerender('3d577e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/PreviewEject.vue"
export default component.exports